(() => {
      const root = document.getElementById('vcxkb-amapola-preview');
      if (!root) return;

      const stickyMode = root.dataset.stickyMode || 'subnav';
      const hero = root.querySelector('[data-vcxkb-hero]');
      const heroForm = hero ? hero.querySelector('.vcxkb-form--hero') : null;
      const finalSignup = root.querySelector('[data-vcxkb-final-signup]');
      const sticky = root.querySelector('[data-vcxkb-sticky]');
      let finalVisible = false;

      const setSticky = () => {
        if (root.classList.contains('is-sticky-expanded')) return;
        if (stickyMode !== 'signup') {
          root.classList.remove('is-sticky-visible');
          if (sticky) sticky.setAttribute('aria-hidden', 'true');
          return;
        }
        // The sticky signup appears only after the hero email form has fully
        // scrolled above the viewport. It remains hidden while any part of the
        // hero form is still visible.
        const heroFormRect = heroForm ? heroForm.getBoundingClientRect() : null;
        const heroFormIsPastViewport = heroFormRect ? heroFormRect.bottom <= 0 : false;
        const shouldShow = heroFormIsPastViewport && !finalVisible;
        root.classList.toggle('is-sticky-visible', shouldShow);
        if (sticky) sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      if ('IntersectionObserver' in window && finalSignup) {
        const observer = new IntersectionObserver((entries) => {
          finalVisible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio > 0.08);
          setSticky();
        }, { threshold: [0, .08, .2, .45], rootMargin: '0px 0px -12% 0px' });
        observer.observe(finalSignup);
      }

      window.addEventListener('scroll', setSticky, { passive: true });
      window.addEventListener('resize', setSticky, { passive: true });
      setSticky();

      // Play the behind-the-scenes film only while it is meaningfully visible.
      const btsVideo = root.querySelector('.js-vcxkb-bts-video');
      if (btsVideo) {
        btsVideo.muted = true;
        btsVideo.defaultMuted = true;

        const playBtsVideo = () => {
          const playRequest = btsVideo.play();
          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(() => {});
          }
        };

        const pauseBtsVideo = () => {
          if (!btsVideo.paused) btsVideo.pause();
        };

        if ('IntersectionObserver' in window) {
          const btsVideoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !document.hidden) {
                playBtsVideo();
              } else {
                pauseBtsVideo();
              }
            });
          }, { threshold: [0, .15, .35, .6, 1] });

          btsVideoObserver.observe(btsVideo);
        } else {
          const updateBtsVideo = () => {
            const rect = btsVideo.getBoundingClientRect();
            const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            const visibleRatio = rect.height ? visibleHeight / rect.height : 0;
            if (visibleRatio >= .35 && !document.hidden) playBtsVideo();
            else pauseBtsVideo();
          };
          window.addEventListener('scroll', updateBtsVideo, { passive: true });
          window.addEventListener('resize', updateBtsVideo, { passive: true });
          updateBtsVideo();
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            pauseBtsVideo();
          } else {
            const rect = btsVideo.getBoundingClientRect();
            const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            if (rect.height && visibleHeight / rect.height >= .35) playBtsVideo();
          }
        });
      }


      const horizontalWorld = root.querySelector('[data-vcxkb-horizontal-world]');
      const horizontalTrack = horizontalWorld ? horizontalWorld.querySelector('.vcxkb-place-row__track') : null;
      const horizontalItems = horizontalWorld ? Array.from(horizontalWorld.querySelectorAll('.vcxkb-place-row__item')) : [];

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const updateHorizontalWorld = () => {
        if (!horizontalWorld || !horizontalTrack) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const mobile = window.innerWidth < 750;

        if (mobile || reducedMotion) {
          horizontalTrack.style.transform = '';
          horizontalItems.forEach((item) => {
            item.style.transform = '';
            const img = item.querySelector('img');
            if (img) img.style.transform = '';
          });
          horizontalWorld.classList.add('is-world-active');
          return;
        }

        const rect = horizontalWorld.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const sectionScrollable = Math.max(1, horizontalWorld.offsetHeight - vh);
        const progress = clamp(-rect.top / sectionScrollable, 0, 1);

        // End the pinned scroll when the final Andalusian horse image is fully visible,
        // rather than forcing the full track to travel all the way to its end.
        const lastItem = horizontalItems[horizontalItems.length - 1];
        const endInset = Math.min(window.innerWidth * 0.08, 120);
        const finalX = lastItem
          ? Math.max(0, lastItem.offsetLeft + lastItem.offsetWidth - (window.innerWidth - endInset))
          : Math.max(0, horizontalTrack.scrollWidth - window.innerWidth);
        const maxX = Math.min(Math.max(0, horizontalTrack.scrollWidth - window.innerWidth), finalX);
        const x = -progress * maxX;

        horizontalWorld.classList.toggle('is-world-active', rect.top < vh * .72 && rect.bottom > vh * .18);
        horizontalWorld.classList.toggle('is-world-complete', progress >= .985);
        horizontalTrack.style.transform = `translate3d(${x.toFixed(2)}px, 0, 0)`;

        const viewportCenter = window.innerWidth / 2;

        horizontalItems.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenter = itemRect.left + itemRect.width / 2;
          const distance = clamp(Math.abs(itemCenter - viewportCenter) / viewportCenter, 0, 1);
          const depth = Number(item.dataset.worldDepth || 1);
          const direction = index % 2 === 0 ? 1 : -1;
          const y = direction * (10 + depth * 7) * (1 - distance) + (progress - .5) * depth * 8;
          const itemScale = 1 + (1 - distance) * .018;

          item.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) scale(${itemScale.toFixed(4)})`;

          const img = item.querySelector('img');
          if (img) {
            const imgScale = 1.055 - (1 - distance) * .045;
            const imgY = direction * (distance - .5) * depth * 7;
            img.style.transform = `translate3d(0, ${imgY.toFixed(2)}px, 0) scale(${imgScale.toFixed(4)})`;
          }
        });
      };



      // Editorial reveal + scroll-fill motion inspired by the supplied references.
      const motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealSelectors = [
        '.vcxkb-statement',
        '.vcxkb-category-card',
        '.vcxkb-collection-copy',
        '.vcxkb-centered-title',
        '.vcxkb-world-intro',
        '.vcxkb-place-row',
        '.vcxkb-story-copy',
        '.vcxkb-video-shell',
        '.vcxkb-collage__item',
        '.vcxkb-final-signup'
      ];

      if (motionAllowed) {
        root.classList.add('vcxkb-motion-ready');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => root.classList.add('is-loaded'));
        });

        const revealItems = root.querySelectorAll(revealSelectors.join(','));
        revealItems.forEach((item) => item.classList.add('vcxkb-reveal'));

        if ('IntersectionObserver' in window) {
          const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-inview');
                revealObserver.unobserve(entry.target);
              }
            });
          }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

          revealItems.forEach((item) => revealObserver.observe(item));
        } else {
          revealItems.forEach((item) => item.classList.add('is-inview'));
        }
      } else {
        root.classList.add('is-loaded');
      }

      const lineReaders = Array.from(root.querySelectorAll('.js-vcxkb-line-reader'));
      const lineReaderState = new Map();

      const getPlainParagraphs = (block) => {
        const raw = block.dataset.vcxkbOriginalText || (block.innerText || block.textContent || '');
        block.dataset.vcxkbOriginalText = raw;
        return raw
          .replace(/\u00a0/g, ' ')
          .trim()
          .split(/\n\s*\n|\n{2,}/)
          .map((paragraph) => paragraph.replace(/\s+/g, ' ').trim())
          .filter(Boolean);
      };

      const buildMeasureParagraph = (paragraph) => {
        const measure = document.createElement('p');
        measure.className = 'vcxkb-line-reader__paragraph vcxkb-line-reader__measure-paragraph';

        paragraph.split(/(\s+)/).forEach((piece) => {
          if (!piece) return;
          if (/^\s+$/.test(piece)) {
            const space = document.createElement('span');
            space.className = 'vcxkb-line-reader__space';
            space.textContent = ' ';
            measure.appendChild(space);
          } else {
            const word = document.createElement('span');
            word.className = 'vcxkb-line-reader__word';
            word.textContent = piece;
            measure.appendChild(word);
          }
        });

        return measure;
      };

      const groupMeasuredWordsIntoLines = (measureParagraph) => {
        const words = Array.from(measureParagraph.querySelectorAll('.vcxkb-line-reader__word'));
        const lines = [];
        const tolerance = 3;

        words.forEach((word) => {
          const top = word.offsetTop;
          let line = lines.find((candidate) => Math.abs(candidate.top - top) <= tolerance);
          if (!line) {
            line = { top, words: [] };
            lines.push(line);
          }
          line.words.push(word.textContent);
        });

        return lines
          .sort((a, b) => a.top - b.top)
          .map((line) => line.words.join(' '));
      };

      const createLine = (text) => {
        const line = document.createElement('span');
        line.className = 'vcxkb-line-reader__line';
        line.style.setProperty('--vcxkb-line-fill', '0%');

        const base = document.createElement('span');
        base.className = 'vcxkb-line-reader__base';
        base.textContent = text;

        const fill = document.createElement('span');
        fill.className = 'vcxkb-line-reader__fill';
        fill.setAttribute('aria-hidden', 'true');

        const fillInner = document.createElement('span');
        fillInner.className = 'vcxkb-line-reader__fill-inner';
        fillInner.textContent = text;

        fill.appendChild(fillInner);
        line.appendChild(base);
        line.appendChild(fill);

        return line;
      };

      const prepareLineReader = (block) => {
        if (!block) return [];

        const paragraphs = getPlainParagraphs(block);
        block.innerHTML = '';

        const measureWrap = document.createElement('div');
        measureWrap.className = 'vcxkb-line-reader__measure';
        paragraphs.forEach((paragraph) => measureWrap.appendChild(buildMeasureParagraph(paragraph)));
        block.appendChild(measureWrap);

        // Force layout so offsetTop is accurate.
        measureWrap.getBoundingClientRect();

        const output = document.createDocumentFragment();
        const allLines = [];

        Array.from(measureWrap.children).forEach((measureParagraph) => {
          const p = document.createElement('p');
          p.className = 'vcxkb-line-reader__paragraph';

          const lineTexts = groupMeasuredWordsIntoLines(measureParagraph);
          lineTexts.forEach((lineText) => {
            const line = createLine(lineText);
            p.appendChild(line);
            allLines.push(line);
          });

          output.appendChild(p);
        });

        block.innerHTML = '';
        block.appendChild(output);

        lineReaderState.set(block, { lines: allLines });
        return allLines;
      };

      const prepareAllLineReaders = () => {
        lineReaders.forEach((block) => prepareLineReader(block));
        updateLineReaders();
      };

      const updateLineReaders = () => {
        const vh = window.innerHeight || document.documentElement.clientHeight;

        lineReaders.forEach((block) => {
          const state = lineReaderState.get(block);
          const lines = state ? state.lines : [];
          if (!lines.length) return;

          const rect = block.getBoundingClientRect();

          // The whole paragraph becomes a scroll timeline. Each measured line
          // receives its own subsection of progress, filling left-to-right.
          const start = vh * 0.88;
          const finish = vh * 0.20;
          const travel = Math.max(1, start - finish + rect.height * 0.85);
          const raw = (start - rect.top) / travel;
          const progress = Math.min(1, Math.max(0, raw));

          const total = lines.length;
          const overlap = 0.42;

          lines.forEach((line, index) => {
            const lineStart = (index / total) * (1 - overlap);
            const lineEnd = lineStart + ((1 / total) * (1 + overlap));
            const local = Math.min(1, Math.max(0, (progress - lineStart) / Math.max(0.001, lineEnd - lineStart)));
            const eased = local < 0.5
              ? 2 * local * local
              : 1 - Math.pow(-2 * local + 2, 2) / 2;

            line.style.setProperty('--vcxkb-line-fill', `${(eased * 100).toFixed(2)}%`);
            line.classList.toggle('is-active', eased > 0 && eased < 1);
            line.classList.toggle('is-complete', eased >= 1);
          });
        });
      };

      let lineReaderResizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(lineReaderResizeTimer);
        lineReaderResizeTimer = window.setTimeout(prepareAllLineReaders, 160);
      }, { passive: true });

      prepareAllLineReaders();

      let ticking = false;
      const requestMotionUpdate = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateLineReaders();
          updateHorizontalWorld();

          if (motionAllowed) {
            const collageItems = root.querySelectorAll('.vcxkb-collage__item');
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const mobileParallax = window.innerWidth <= 749;
            collageItems.forEach((item) => {
              const rect = item.getBoundingClientRect();
              if (rect.bottom < -120 || rect.top > vh + 120) return;
              const depth = Number(item.dataset.parallaxDepth || 1);
              const centerOffset = (rect.top + rect.height / 2 - vh / 2) / vh;
              const travel = mobileParallax ? -10 : -22;
              const y = centerOffset * depth * travel;
              const zoom = mobileParallax ? 1 : 1.69;
              item.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) scale(${zoom})`;
            });
          }

          ticking = false;
        });
      };

      window.addEventListener('scroll', requestMotionUpdate, { passive: true });
      window.addEventListener('resize', requestMotionUpdate, { passive: true });
      requestMotionUpdate();


      const serialize = (obj) => new URLSearchParams(obj).toString();

      async function submitToKlaviyo(form, email) {
        const listId = (form.dataset.listId || 'VxKgtH').trim();
        const companyId = (form.dataset.companyId || 'WJ27kk').trim();

        if (!listId || !companyId) {
          throw new Error('Missing Klaviyo list ID or public company ID.');
        }

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: {
                      email: {
                        marketing: { consent: 'SUBSCRIBED' }
                      }
                    }
                  }
                }
              },
              custom_source: 'VC x Kristopher Brock Fall 2026 Landing'
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId }
              }
            }
          }
        };

        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
          {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'revision': '2026-04-15'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          let detail = '';
          try {
            detail = await response.text();
          } catch (_) {}
          throw new Error(`Klaviyo response ${response.status}${detail ? `: ${detail}` : ''}`);
        }

        return response;
      }

      root.querySelectorAll('.js-vcxkb-form').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const emailInput = form.querySelector('input[type="email"]');
          const honeypot = form.querySelector('input[name="company_url"]');
          const button = form.querySelector('button[type="submit"]');
          const message = form.querySelector('.js-vcxkb-message');
          const email = emailInput ? emailInput.value.trim() : '';

          if (honeypot && honeypot.value) return;
          if (!email) return;

          if (button) button.disabled = true;
          if (message) message.textContent = 'Submitting...';

          try {
            const response = await submitToKlaviyo(form, email);
            if (!response || (response.status >= 200 && response.status < 300)) {
              root.dataset.vcxkbSubmitted = 'true';
              root.classList.add('is-vcxkb-confirmed');

              root.querySelectorAll('.js-vcxkb-form').forEach((otherForm) => {
                const otherInput = otherForm.querySelector('input[type="email"]');
                const otherButton = otherForm.querySelector('button[type="submit"]');
                const otherMessage = otherForm.querySelector('.js-vcxkb-message');

                otherForm.classList.add('is-vcxkb-confirmed');
                if (otherInput) {
                  otherInput.value = '';
                  otherInput.disabled = true;
                }
                if (otherButton) {
                  otherButton.disabled = true;
                  otherButton.textContent = "Confirmed. You're on the list.";
                  otherButton.setAttribute('aria-label', "Confirmed. You're on the list.");
                }
                if (otherMessage) otherMessage.textContent = '';
              });

              const submittedFromSticky = Boolean(form.closest('[data-vcxkb-sticky]'));
              const submittedFromExpandedPopup = submittedFromSticky && root.classList.contains('is-sticky-expanded');
              root.dispatchEvent(new CustomEvent('vcxkb:signup-confirmed', {
                detail: {
                  submittedFromSticky,
                  submittedFromExpandedPopup
                }
              }));
            } else {
              throw new Error('Klaviyo response status ' + response.status);
            }
          } catch (error) {
            if (message) message.textContent = 'Something went wrong. Please try again.';
            console.warn('VC x KB Klaviyo signup error:', error);
          } finally {
            if (button && !form.classList.contains('is-vcxkb-confirmed')) button.disabled = false;
          }
        });
      });
    })();
  
    


(() => {
  const root = document.getElementById('vcxkb-amapola-preview');
  if (!root) return;

  const marquee = root.querySelector('.vcxkb-world-marquee');
  const track = marquee?.querySelector('.vcxkb-world-marquee__track');
  const sourceSet = track?.querySelector('.vcxkb-world-marquee__set');
  if (!marquee || !track || !sourceSet) return;

  const SPEED_PX_PER_SECOND = 101.4;
  const originalFigures = Array.from(sourceSet.querySelectorAll(':scope > figure'));
  if (!originalFigures.length) return;

  let repeatDistance = 0;
  let offset = 0;
  let previousTime = 0;
  let animationFrame = 0;
  let resizeFrame = 0;

  const cloneFigure = (figure, sequenceIndex) => {
    const clone = figure.cloneNode(true);
    clone.dataset.vcxkbSequence = String(sequenceIndex);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('img').forEach((img) => {
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
    });
    return clone;
  };

  const rebuild = () => {
    // Flatten the original sequence so CSS gap is the single source of spacing.
    track.replaceChildren();
    originalFigures.forEach((figure) => {
      figure.dataset.vcxkbSequence = '0';
      track.appendChild(figure);
    });

    // Add the first repeated sequence before measuring. The x-position of its first
    // image is the exact loop distance, including the final-to-first gap.
    originalFigures.forEach((figure) => track.appendChild(cloneFigure(figure, 1)));

    const firstOriginal = track.querySelector('figure[data-vcxkb-sequence="0"]');
    const firstRepeat = track.querySelector('figure[data-vcxkb-sequence="1"]');
    if (!firstOriginal || !firstRepeat) return;

    repeatDistance = firstRepeat.offsetLeft - firstOriginal.offsetLeft;
    if (!(repeatDistance > 0)) return;

    // Add as many full sequences as needed so the viewport is always covered.
    let sequenceIndex = 2;
    while (track.scrollWidth < marquee.clientWidth + repeatDistance * 2) {
      originalFigures.forEach((figure) => track.appendChild(cloneFigure(figure, sequenceIndex)));
      sequenceIndex += 1;
    }

    offset = ((offset % repeatDistance) + repeatDistance) % repeatDistance;
    track.style.transform = `translate3d(${-offset}px,0,0)`;
  };

  const scheduleRebuild = () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(rebuild);
  };

  const tick = (time) => {
    if (!previousTime) previousTime = time;
    const delta = Math.min((time - previousTime) / 1000, 0.1);
    previousTime = time;

    if (!document.hidden && repeatDistance > 0) {
      offset = (offset + SPEED_PX_PER_SECOND * delta) % repeatDistance;
      track.style.transform = `translate3d(${-offset}px,0,0)`;
    }

    animationFrame = requestAnimationFrame(tick);
  };

  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleRebuild) : null;
  resizeObserver?.observe(marquee);
  window.addEventListener('resize', scheduleRebuild, { passive: true });
  document.addEventListener('visibilitychange', () => { previousTime = 0; });

  originalFigures.forEach((figure) => {
    const img = figure.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', scheduleRebuild, { once: true });
  });

  rebuild();
  animationFrame = requestAnimationFrame(tick);
})();



(() => {
  const root = document.getElementById('vcxkb-amapola-preview');
  if (!root) return;

  const collage = root.querySelector('.vcxkb-collage--editorial');
  const finalSignup = root.querySelector('.vcxkb-final-signup');
  if (!collage || !finalSignup) return;

  let frame = 0;

  const setExactFinalGap = () => {
    finalSignup.style.marginTop = '0px';

    const items = Array.from(collage.querySelectorAll('.vcxkb-collage__item'));
    if (!items.length) return;

    const collageRect = collage.getBoundingClientRect();
    let visualBottom = collageRect.top;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      visualBottom = Math.max(visualBottom, rect.bottom);
    });

    const unusedSpace = Math.max(0, collageRect.bottom - visualBottom);
    finalSignup.style.marginTop = `${-unusedSpace}px`;
  };

  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => requestAnimationFrame(setExactFinalGap));
  };

  window.addEventListener('resize', schedule, { passive: true });

  collage.querySelectorAll('img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', schedule, { once: true });
  });

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    observer.observe(collage);
  }

  schedule();
})();


(() => {
  const root = document.getElementById('vcxkb-amapola-preview');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('.vcxkb-category-card'));
  const collectionTriggers = Array.from(root.querySelectorAll('[data-vcxkb-collection-trigger]'));
  const compactSignupTriggers = Array.from(root.querySelectorAll('[data-vcxkb-signup-trigger]'));
  const signupTriggers = [...cards, ...collectionTriggers, ...compactSignupTriggers];
  const stickyMode = root.dataset.stickyMode || 'subnav';
  const sticky = root.querySelector('[data-vcxkb-sticky]');
  const backdrop = root.querySelector('[data-vcxkb-signup-backdrop]');
  const minimize = root.querySelector('[data-vcxkb-signup-minimize]');
  const stickyEmail = sticky?.querySelector('input[type="email"]');
  const popupInner = sticky?.querySelector('.vcxkb-sticky-signup__inner');
  if (!signupTriggers.length || !sticky || !popupInner) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileViewport = window.matchMedia('(max-width: 680px)');
  const fadeDuration = 280;
  let lastTrigger = null;
  let activeAnimation = null;
  let isAnimating = false;
  let popupResizeFrame = 0;
  let lockedViewportWidth = 0;
  let lockedViewportHeight = 0;

  const unlockPopupGeometry = () => {
    cancelAnimationFrame(popupResizeFrame);
    popupResizeFrame = 0;
    popupInner.style.removeProperty('--vcxkb-popup-locked-width');
    popupInner.style.removeProperty('--vcxkb-popup-locked-height');
  };

  const lockPopupGeometry = () => {
    if (!root.classList.contains('is-sticky-expanded')) return;

    /* Measure the popup's intended responsive footprint, then freeze those exact
       pixels until a genuine browser-window resize occurs. Content interaction,
       validation, focus, and close-button states cannot change the box size. */
    unlockPopupGeometry();
    const rect = popupInner.getBoundingClientRect();
    popupInner.style.setProperty('--vcxkb-popup-locked-width', `${rect.width}px`);
    popupInner.style.setProperty('--vcxkb-popup-locked-height', `${rect.height}px`);
    lockedViewportWidth = window.innerWidth;
    lockedViewportHeight = window.innerHeight;
  };

  const schedulePopupGeometryRefresh = () => {
    if (!root.classList.contains('is-sticky-expanded')) return;

    const widthChanged = Math.abs(window.innerWidth - lockedViewportWidth) > 1;
    const heightChanged = Math.abs(window.innerHeight - lockedViewportHeight) > 1;

    /* Mobile software keyboards commonly fire height-only resize events. Those
       are input interactions, not a browser-window resize, so keep the popup
       locked. Width/orientation changes still recalculate the geometry. */
    if (mobileViewport.matches && !widthChanged) return;
    if (!widthChanged && !heightChanged) return;

    cancelAnimationFrame(popupResizeFrame);
    popupResizeFrame = requestAnimationFrame(() => {
      popupResizeFrame = requestAnimationFrame(lockPopupGeometry);
    });
  };

  const clearAnimation = () => {
    if (activeAnimation) {
      activeAnimation.onfinish = null;
      activeAnimation.oncancel = null;
      activeAnimation.cancel();
    }
    activeAnimation = null;
    sticky.style.removeProperty('opacity');
    sticky.style.removeProperty('transform');
    sticky.style.removeProperty('transform-origin');
  };

  const expandSignup = (trigger) => {
    if (root.classList.contains('is-sticky-expanded') || isAnimating) return;

    lastTrigger = trigger || document.activeElement;
    clearAnimation();
    root.classList.add('is-sticky-visible', 'is-sticky-expanded');
    sticky.setAttribute('aria-hidden', 'false');
    sticky.setAttribute('aria-modal', 'true');
    backdrop?.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    lockPopupGeometry();

    if (reducedMotion.matches) {
      stickyEmail?.focus({ preventScroll: true });
      return;
    }

    isAnimating = true;
    activeAnimation = sticky.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      { duration: fadeDuration, easing: 'ease', fill: 'none' }
    );
    activeAnimation.onfinish = () => {
      activeAnimation = null;
      isAnimating = false;
      sticky.style.removeProperty('opacity');
      stickyEmail?.focus({ preventScroll: true });
    };
    activeAnimation.oncancel = () => {
      activeAnimation = null;
      isAnimating = false;
    };
  };

  const minimizeSignup = () => {
    if (!root.classList.contains('is-sticky-expanded') || isAnimating) return;

    const finish = () => {
      if (activeAnimation) {
        activeAnimation.onfinish = null;
        activeAnimation.oncancel = null;
        activeAnimation.cancel();
      }
      activeAnimation = null;
      root.classList.remove('is-sticky-expanded');
      unlockPopupGeometry();
      sticky.setAttribute('aria-modal', 'false');
      backdrop?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      sticky.style.removeProperty('opacity');
      sticky.style.removeProperty('transform');
      sticky.style.removeProperty('transform-origin');
      isAnimating = false;

      // Restore the compact footer only when that mode is explicitly enabled.
      if (stickyMode === 'signup') {
        root.classList.add('is-sticky-visible');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        root.classList.remove('is-sticky-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }

      if (lastTrigger instanceof HTMLElement) {
        lastTrigger.focus({ preventScroll: true });
      }
    };

    if (reducedMotion.matches) {
      finish();
      return;
    }

    clearAnimation();
    isAnimating = true;
    activeAnimation = sticky.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { duration: fadeDuration, easing: 'ease', fill: 'none' }
    );
    activeAnimation.onfinish = finish;
    activeAnimation.oncancel = () => {
      activeAnimation = null;
      isAnimating = false;
      sticky.style.removeProperty('opacity');
    };
  };

  const showConfirmedSticky = (event) => {
    const submittedFromExpandedPopup = Boolean(event?.detail?.submittedFromExpandedPopup);

    if (stickyMode !== 'signup' && submittedFromExpandedPopup) {
      root.classList.add('is-vcxkb-confirmed', 'is-sticky-visible', 'is-sticky-expanded');
      sticky.setAttribute('aria-hidden', 'false');
      sticky.setAttribute('aria-modal', 'true');
      backdrop?.setAttribute('aria-hidden', 'false');
      return;
    }

    // In-body forms should not force the sticky footer into view. Its normal
    // scroll visibility logic remains authoritative; the confirmed class will
    // automatically style it once it is legitimately revealed.
    if (!submittedFromExpandedPopup && !root.classList.contains('is-sticky-expanded')) {
      root.classList.add('is-vcxkb-confirmed');
      return;
    }

    const finishConfirmedState = () => {
      if (activeAnimation) {
        activeAnimation.onfinish = null;
        activeAnimation.oncancel = null;
        activeAnimation.cancel();
      }
      activeAnimation = null;
      isAnimating = false;
      root.classList.remove('is-sticky-expanded');
      unlockPopupGeometry();
      root.classList.add('is-sticky-visible', 'is-vcxkb-confirmed');
      sticky.setAttribute('aria-hidden', 'false');
      sticky.setAttribute('aria-modal', 'false');
      backdrop?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      sticky.style.removeProperty('opacity');
      sticky.style.removeProperty('transform');
      sticky.style.removeProperty('transform-origin');
    };

    if (!root.classList.contains('is-sticky-expanded') || reducedMotion.matches) {
      finishConfirmedState();
      return;
    }

    clearAnimation();
    isAnimating = true;
    activeAnimation = sticky.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      { duration: fadeDuration, easing: 'ease', fill: 'none' }
    );
    activeAnimation.onfinish = finishConfirmedState;
    activeAnimation.oncancel = finishConfirmedState;
  };

  root.addEventListener('vcxkb:signup-confirmed', showConfirmedSticky);

  signupTriggers.forEach((card) => {
    card.addEventListener('click', () => expandSignup(card));
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        expandSignup(card);
      }
    });
  });

  minimize?.addEventListener('click', minimizeSignup);
  backdrop?.addEventListener('click', minimizeSignup);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') minimizeSignup();
  });
  window.addEventListener('resize', schedulePopupGeometryRefresh, { passive: true });
})();


(() => {
  const root = document.getElementById('vcxkb-amapola-preview');
  if (!root) return;

  const subnav = root.querySelector('[data-vcxkb-subnav]');
  const tabs = Array.from(root.querySelectorAll('[data-vcxkb-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-vcxkb-panel]'));
  if (!subnav || !tabs.length || !panels.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileNav = window.matchMedia('(max-width: 680px)');
  const lockup = subnav.querySelector('.vcxkb-campaign-nav__lockup');
  const links = subnav.querySelector('.vcxkb-campaign-nav__links');
  const normalizePanel = (value) => value === 'lookbook' ? 'lookbook' : 'about';

  const updateHeaderOffset = () => {
    const selectors = [
      '#vcxkb-local-site-header',
      'sticky-header',
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      '.header-wrapper',
      '[data-header-wrapper]',
      'body > header',
      'header[role="banner"]'
    ];
    let offset = 0;
    document.querySelectorAll(selectors.join(',')).forEach((element) => {
      if (root.contains(element)) return;
      const relation = element.compareDocumentPosition(root);
      if (!(relation & Node.DOCUMENT_POSITION_FOLLOWING) && !element.contains(root)) return;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
      if (rect.width < 1 || rect.height < 1 || rect.bottom <= 0) return;
      offset = Math.max(offset, rect.bottom);
    });
    root.style.setProperty('--vcxkb-global-header-offset', `${Math.max(0, Math.round(offset))}px`);
  };

  const updateCampaignLeftEdge = () => {
    if (mobileNav.matches) {
      root.style.removeProperty('--vcxkb-campaign-left-edge');
      return;
    }
    const headers = Array.from(document.querySelectorAll([
      '#vcxkb-local-site-header',
      'sticky-header',
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      '.header-wrapper',
      '[data-header-wrapper]'
    ].join(','))).filter((element) => !root.contains(element));
    const matches = [];
    headers.forEach((header) => {
      header.querySelectorAll('a, button, span').forEach((element) => {
        if ((element.textContent || '').trim().toLowerCase() !== 'new') return;
        const style = getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return;
        if (rect.width < 1 || rect.height < 1 || rect.right <= 0 || rect.left >= window.innerWidth) return;
        matches.push(rect);
      });
    });
    if (matches.length) {
      matches.sort((a, b) => Math.abs(a.top) - Math.abs(b.top) || a.left - b.left);
      root.style.setProperty('--vcxkb-campaign-left-edge', `${Math.max(16, Math.round(matches[0].left))}px`);
    } else {
      root.style.removeProperty('--vcxkb-campaign-left-edge');
    }
  };

  const updateLockupMode = () => {
    if (!lockup || !links || mobileNav.matches) {
      subnav.classList.remove('is-lockup-compact');
      return;
    }
    subnav.classList.remove('is-lockup-compact');
    const lockupRect = lockup.getBoundingClientRect();
    const linksRect = links.getBoundingClientRect();
    subnav.classList.toggle('is-lockup-compact', lockupRect.right + 10 > linksRect.left);
  };

  const refreshNav = () => {
    updateHeaderOffset();
    updateCampaignLeftEdge();
    updateLockupMode();
    root.classList.add('is-subnav-visible');
    root.dataset.subnavRevealed = 'true';
    subnav.setAttribute('aria-hidden', 'false');
  };

  const pauseLookbookVideos = () => {
    root.querySelectorAll('.js-vcxkb-lookbook-video').forEach((video) => video.pause());
  };

  const setPanel = (requested, options = {}) => {
    const name = normalizePanel(requested);
    const active = panels.find((panel) => panel.dataset.vcxkbPanel === name);
    if (!active) return;

    panels.forEach((panel) => {
      const selected = panel === active;
      panel.hidden = !selected;
      panel.classList.toggle('is-active', selected);
    });
    tabs.forEach((tab) => {
      const selected = tab.dataset.vcxkbTab === name;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    root.dataset.activePanel = name;
    if (name !== 'lookbook') pauseLookbookVideos();
    refreshNav();

    if (options.updateHash !== false) {
      const hash = name === 'lookbook' ? '#lookbook' : '#about';
      if (window.location.hash !== hash) history.pushState({ vcxkbPanel: name }, '', hash);
    }

    if (options.scroll !== false) window.scrollTo({ top: 0, behavior: 'auto' });

    if (!reducedMotion.matches && active.animate) {
      active.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 280, easing: 'ease-out' });
    }
  };

  tabs.forEach((tab) => tab.addEventListener('click', () => setPanel(tab.dataset.vcxkbTab)));
  const syncPanelFromLocation = (options = {}) => {
    setPanel(window.location.hash.slice(1), { updateHash: false, ...options });
  };

  window.addEventListener('hashchange', () => syncPanelFromLocation());
  window.addEventListener('popstate', () => syncPanelFromLocation());
  window.addEventListener('pageshow', () => {
    syncPanelFromLocation({ scroll: false });
    requestAnimationFrame(refreshNav);
  });
  window.addEventListener('resize', refreshNav, { passive: true });
  window.addEventListener('scroll', updateHeaderOffset, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(updateLockupMode).observe(subnav);
  if (document.fonts?.ready) document.fonts.ready.then(updateLockupMode);

  refreshNav();
  syncPanelFromLocation({ scroll: false });

  const videos = Array.from(root.querySelectorAll('.js-vcxkb-lookbook-video'));
  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
  });

  if ('IntersectionObserver' in window && videos.length) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting && entry.intersectionRatio >= .42)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      videos.forEach((video) => {
        if (visible && video === visible.target && root.dataset.activePanel === 'lookbook' && !document.hidden) {
          const request = video.play();
          if (request && typeof request.catch === 'function') request.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, .2, .42, .65, 1] });
    videos.forEach((video) => observer.observe(video));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pauseLookbookVideos();
  });
})();

/* ==========================================================================
   v36 — Shared About/Lookbook conversion rail with delayed Lookbook trigger
   ========================================================================== */
(() => {
  const root = document.getElementById('vcxkb-amapola-preview');
  if (!root) return;

  const conversion = root.querySelector('[data-vcxkb-campaign-conversion]');
  if (!conversion) return;

  const lookbookTriggers = Array.from(root.querySelectorAll('[data-vcxkb-lookbook-trigger]'));
  const nativeMobile = root.querySelector('[data-vcxkb-about-native-cta]');
  const desktopHeroForm = root.querySelector('[data-vcxkb-panel="about"] .vcxkb-form--hero');
  const aboutHero = root.querySelector('[data-vcxkb-panel="about"] [data-vcxkb-hero]');
  const lookbookIntro = root.querySelector('[data-vcxkb-panel="lookbook"] .vcxkb-lookbook-intro');
  const lookbookHero = root.querySelector('[data-vcxkb-panel="lookbook"] .vcxkb-lb-opener');
  const firstLookbookModule = root.querySelector('[data-vcxkb-panel="lookbook"] .vcxkb-lb-module');
  const finalSignup = root.querySelector('[data-vcxkb-final-signup]');
  const mobile = window.matchMedia('(max-width: 680px)');
  let frame = 0;

  const activateLookbook = () => {
    const tab = root.querySelector('.vcxkb-campaign-nav [data-vcxkb-tab="lookbook"]');
    if (tab instanceof HTMLElement) tab.click();
    else {
      history.pushState({ vcxkbPanel: 'lookbook' }, '', '#lookbook');
      window.dispatchEvent(new HashChangeEvent('hashchange'));
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  };
  lookbookTriggers.forEach((trigger) => trigger.addEventListener('click', activateLookbook));

  const hasPassed = (target, fallback = 0.8) => {
    if (!target || getComputedStyle(target).display === 'none') return window.scrollY > window.innerHeight * fallback;
    const rect = target.getBoundingClientRect();
    return rect.height > 0 && rect.bottom <= 0;
  };

  const nearFinalSignup = () => {
    if (root.dataset.activePanel !== 'about' || !finalSignup || getComputedStyle(finalSignup).display === 'none') return false;
    const rect = finalSignup.getBoundingClientRect();
    return rect.top <= window.innerHeight + 72 && rect.bottom >= -72;
  };

  const hasReachedLookbookRailTrigger = () => {
    if (!firstLookbookModule || getComputedStyle(firstLookbookModule).display === 'none') {
      return hasPassed(lookbookIntro || lookbookHero, 0.65);
    }

    const rect = firstLookbookModule.getBoundingClientRect();
    if (rect.height <= 0) return false;

    // Preserve the immersive opening: reveal only after the visitor has moved
    // into the first media module. Cap the distance on very tall mobile rows.
    const passedDistance = Math.min(rect.height * 0.35, window.innerHeight * 0.45);
    return rect.top <= -passedDistance;
  };

  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const panel = root.dataset.activePanel === 'lookbook' ? 'lookbook' : 'about';
      const aboutTrigger = mobile.matches ? nativeMobile : desktopHeroForm;
      const aboutPassed = hasPassed(aboutTrigger || aboutHero);
      const lookbookPassed = hasReachedLookbookRailTrigger();
      const popupOpen = root.classList.contains('is-sticky-expanded');
      const confirmed = root.classList.contains('is-vcxkb-confirmed');
      const shouldShow = (panel === 'about' ? aboutPassed && !nearFinalSignup() : lookbookPassed)
        && !popupOpen
        && !confirmed;

      root.classList.toggle('is-campaign-conversion-visible', shouldShow);
      conversion.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      conversion.querySelectorAll('button, a').forEach((element) => {
        const variant = element.closest('.vcxkb-campaign-conversion__desktop');
        const variantVisible = !variant
          || (panel === 'about' && variant.classList.contains('vcxkb-campaign-conversion__desktop--about'))
          || (panel === 'lookbook' && variant.classList.contains('vcxkb-campaign-conversion__desktop--lookbook'));
        element.tabIndex = shouldShow && variantVisible ? 0 : -1;
      });
    });
  };

  const observer = new MutationObserver(update);
  observer.observe(root, { attributes: true, attributeFilter: ['class', 'data-active-panel'] });
  ['scroll', 'resize', 'hashchange', 'popstate', 'pageshow'].forEach((eventName) => {
    window.addEventListener(eventName, update, { passive: eventName === 'scroll' || eventName === 'resize' });
  });
  root.addEventListener('vcxkb:signup-confirmed', update);
  mobile.addEventListener?.('change', update);
  update();
})();
